import {Box, IconButton, MenuItem, Stack, styled, Typography} from '@mui/material'

export const StyledButton = styled(IconButton)(({theme}) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '3rem',
  width: '3rem',
  padding: 0,
  height: '3rem',
  textTransform: 'unset',
  border: `1px solid ${theme.palette.grey[200]}`,
}))

export const UserTitle = styled(Typography)(({theme}) => ({
  color: theme.palette.common.black,
  textAlign: 'end',
  fontWeight: 'bold',
  lineHeight: '1rem',
  fontSize: '0.95rem',
}))

export const UserRole = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[400],
  textAlign: 'end',
  lineHeight: '0.8rem',
  fontSize: '0.75rem',
}))

export const Avatar = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: '3rem',
  width: '3rem',
  height: '3rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const StyledStack = styled(Stack)(() => ({
  maxWidth: 250,
  alignItems: 'center',
  gap: '0.5rem',
  flexDirection: 'row',
}))

export const imageStyle = {
  width: '2rem',
  height: '2rem',
  objectFit: 'cover' as const,
  borderRadius: '50%',
}

export const MenuItemStyled = styled(MenuItem)(() => ({
  justifyContent: 'flex-end',
}))

export const Separator = styled(Stack)(({theme}) => ({
  flex: 1,
  backgroundColor: theme.palette.grey[400],
  height: 1,
  margin: '2px 15px 8px 15px',
}))

export const menuSlotStyle = {width: 'auto', minWidth: 180, mt: 0.5}
